import { render, staticRenderFns } from "./PanamaMap.vue?vue&type=template&id=2e05505a&scoped=true&"
import script from "./PanamaMap.vue?vue&type=script&lang=js&"
export * from "./PanamaMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e05505a",
  null
  
)

export default component.exports